/**
 * Visit / follow-up letter footer sign-off line: First Last (userName)(profileCode).
 * Aligns with CRA-style display elsewhere in CTMS.
 */
export function buildLetterFooterSignOff(user) {
  if (!user || typeof user !== 'object') return '';
  const fn = (user.firstName ?? user.FirstName ?? user.vFirstName ?? '').toString().trim();
  const ln = (user.lastName ?? user.LastName ?? user.vLastName ?? '').toString().trim();
  const full = [fn, ln].filter(Boolean).join(' ').trim();
  // API SessionUserDto uses "Username"; JSON camelCase is "username" (not userName).
  const uname = (
    user.username ??
    user.Username ??
    user.userName ??
    user.UserName ??
    user.vUserName ??
    user.vLoginName ??
    user.loginName ??
    user.LoginName ??
    ''
  )
    .toString()
    .trim();
  const prof = (user.profileCode ?? user.ProfileCode ?? user.vUserTypeCode ?? user.role ?? user.Role ?? '').toString().trim();

  let core;
  if (full && uname) core = `${full} (${uname})`;
  else if (full) core = full;
  else if (uname) core = uname;
  else return '';

  if (prof) return `${core}(${prof})`;
  return core;
}
